<template>
  <PerkContainer
    :icon="isBcom ? 'financing-dark-medium' : 'financing'"
    @value-info-click="openOverlay"
  >
    <Klarna
      class="klarna-perks"
      :price="selectedPrice"
      :is-product-perks-enabled="true"
    />
  </PerkContainer>
</template>
<script setup>
/* istanbul ignore file */
import Klarna from '@common-vue/media-card-large/src/modules/credit-finance/components/Klarna';
import PerkContainer from '@modules/productPerks/components/PerkContainer';
import { useProductPrice } from '@modules/price/composables/useProductPrice';
import { useBrand } from '@composables/useBrand';
import once from '@utils/once';
import { klarnaDetailsClicked } from '../../../features/analytics/productPerks';

const selectedPrice = useProductPrice();
const { isBcom } = useBrand();

const fireAnalytics = once(klarnaDetailsClicked);

const openOverlay = () => {
  const klarnaContainer = document.querySelector('.klarna-container .align-center-middle');
  const klarna = klarnaContainer.childNodes?.[1] || klarnaContainer;

  if (klarna) {
    const { shadowRoot } = klarna;

    if (shadowRoot) {
      const button = shadowRoot.querySelector('button');
      if (button) {
        fireAnalytics();
        button.click();
      }
    }
  }
};
</script>
<style lang="scss">
@import "~settingSCSS";
.klarna-perks {
  ::part(osm-container) {
    background-color: $background-color;
    @include body(large);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
  }
  ::part(osm-cta) {
    display: none;
   }
}
</style>
<style lang="scss" brand="bcom">
.klarna-perks {
  ::part(osm-container) {
    font-family: Avenir, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
}
</style>
<style lang="scss" brand="mcom">
.klarna-perks {
  ::part(osm-container) {
    font-family: Macys Sans,Helvetica Neue,Helvetica,Arial,sans-serif !important;
  }
}
</style>
